<script setup>
import RoundedButton from "@/components/global-themed/buttons/RoundedButton.vue";

const emit = defineEmits(['showTiers']);
defineProps({
  product: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <div class="tw-flex tw-flex-col tw-justify-center tw-gap-3 tw-flex-grow-0">
    <span class="tw-text-primary-300">You are on:</span>
    <RoundedButton
      class="tw-mx-auto"
      variant="outline"
      @click="emit('showTiers')"
    >
      {{ product.tierLabel }}
      <SvgVue
        icon="icons/arrow-right"
        class="tw-ml-2 tw-h-6 tw-w-6"
      />
    </RoundedButton>
  </div>
</template>
